<template>
  <DataTable
    :value="rows"
    data-key="historyId"
    class="potential-table"
    :loading="loading"
    striped-rows
    row-hover
  >
    <Column header="When" style="min-width: 9rem">
      <template #body="{ data }">
        <span class="history-mono text-sm">{{ formatWhen(data.timestamp) }}</span>
      </template>
    </Column>
    <Column field="changedBy" header="Who" style="min-width: 9rem" />
    <Column header="Type" style="min-width: 7rem">
      <template #body="{ data }">
        <Tag :value="typeLabel(data.refType)" :severity="typeSeverity(data.refType)" />
      </template>
    </Column>
    <Column header="Subject" style="min-width: 12rem">
      <template #body="{ data }">
        <div class="history-subject">
          <span>{{ data.refName || '—' }}</span>
          <span v-if="data.refId" class="history-mono text-sm text-color-secondary">{{ data.refId }}</span>
        </div>
      </template>
    </Column>
    <Column header="Field" style="min-width: 8rem">
      <template #body="{ data }">
        <span class="text-sm">{{ data.field || '—' }}</span>
      </template>
    </Column>
    <Column header="Change" style="min-width: 14rem">
      <template #body="{ data }">
        <span class="text-sm">
          <template v-if="data.oldValue">
            <span class="text-color-secondary">{{ truncate(data.oldValue, 30) }}</span>
            →
          </template>
          {{ truncate(data.newValue || '', 30) || '(empty)' }}
        </span>
      </template>
    </Column>
    <Column header="Note" style="min-width: 10rem">
      <template #body="{ data }">
        <span class="text-sm text-color-secondary">{{ data.note || '' }}</span>
      </template>
    </Column>
    <template #empty>
      <div class="p-4 text-center text-color-secondary">No history entries</div>
    </template>
  </DataTable>
</template>

<script setup>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Tag from 'primevue/tag';
import { formatDateTime } from '@/utils/common';

defineOptions({ name: 'HistoryFlatTable' });

defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false }
});

function formatWhen(value) {
  return formatDateTime(value) || value || '—';
}

function typeLabel(type) {
  const map = {
    lead: 'Lead',
    inprogress: 'In Progress',
    driver: 'Driver'
  };
  return map[type] || type || '—';
}

function typeSeverity(type) {
  if (type === 'lead') return 'info';
  if (type === 'inprogress') return 'warn';
  if (type === 'driver') return 'success';
  return 'secondary';
}

function truncate(value, max) {
  const text = String(value ?? '');
  if (text.length <= max) return text;
  return `${text.slice(0, max)}…`;
}
</script>

<style scoped>
.history-subject {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}
.history-mono {
  font-variant-numeric: tabular-nums;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}
</style>
